import {Component, inject, computed, signal, effect, DestroyRef} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import { UserService } from '../../core/user/services/user.service';
import { ReturnConditionsRestService } from './services/return-conditions.rest';
import { ResponseModel } from '../../core/base/response.model';
import { ReturnConditionData } from './models/return.condition.data';
import { PdfService } from '../../core/export/pdf.service';
import { AccountModel } from '../../core/account/account.model';
import {ReturnConditionsService} from "./services/return-conditions.service";


@Component({
  selector: 'app-return-conditions',
  imports: [
    CurrencyPipe,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './return-conditions.component.html',
  styleUrl: './return-conditions.component.scss',
  standalone: true
})
export class ReturnConditionsComponent {
  private userService = inject(UserService);
  private exportPdfService: PdfService = inject(PdfService);
  private returnConditionsService = inject(ReturnConditionsService)

  protected conditions = this.returnConditionsService.conditions;

  savePdf() {
    const data: any = {
      returnDeadlineOrderError: this.conditions()?.returnDeadlineOrderError ? this.conditions()?.returnDeadlineOrderError : 0,
      returnDeadlineExpiry: this.conditions()?.returnDeadlineExpiry ? this.conditions()?.returnDeadlineExpiry : 0,
      returnDeadlineBtmCool: this.conditions()?.returnDeadlineBtmCool ? this.conditions()?.returnDeadlineBtmCool : 0,
      fixedFeePerPacket: this.conditions()?.fixedFeePerPacket ? this.conditions()?.fixedFeePerPacket : 0,
      fixedFeeHighPrice: this.conditions()?.fixedFeeHighPrice ? this.conditions()?.fixedFeeHighPrice : 0,
      minimumValueBtmCool: this.conditions()?.minimumValueBtmCool ? this.conditions()?.minimumValueBtmCool : 0,
      processingFee: this.conditions()?.processingFee ? this.conditions()?.processingFee : 0,
      idf: this.userService.selectedIdf(),
      name: this.userService.pharmacyName(),
    };

    this.exportPdfService.printA5Size(data);
  }

}
